import Box from '@material-ui/core/Box';
import { PayoutStatus } from '@nemuru-eng/js-api-client';
import { Fragment } from 'react';

import { useCustomTheme } from '../../../../../hooks/useCustomTheme';
import { Text } from '../../../../shared/components/Text';
import { PAYOUT_STATUS_DEFINITIONS } from '../constants/constants';

interface PayoutStatusLabelProps {
  payoutStatus: PayoutStatus;
  hideStatusName?: boolean;
}

export function PayoutStatusLabel({ payoutStatus, hideStatusName = false }: PayoutStatusLabelProps) {
  const { palette } = useCustomTheme();
  const richStatus = PAYOUT_STATUS_DEFINITIONS[payoutStatus];

  const getColorByStatus = () => {
    switch (payoutStatus) {
      case PayoutStatus.IN_REVIEW:
        return palette.warning.main;
      case PayoutStatus.PUBLISHING:
        return palette.info.main;
      case PayoutStatus.PUBLISHED:
        return palette.success.dark;
      case PayoutStatus.DISBURSED:
        return palette.success.main;
      default:
        return palette.grey[200];
    }
  };

  return (
    <Fragment>
      {richStatus ? (
        <Fragment>
          <Box bgcolor={getColorByStatus()} className={'circle mr-2'} style={{ marginBottom: '-1px' }} />
          {!hideStatusName && (
            <span>
              <Text tId={richStatus.SECTION_T_ID} />
            </span>
          )}
        </Fragment>
      ) : (
        payoutStatus
      )}
    </Fragment>
  );
}
